import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../models/api-client.js';
import { queryKeys } from '../models/query-keys.js';
import { useSession } from './session-context.jsx';

export function useAdminUsers() {
  const { user } = useSession();
  const queryClient = useQueryClient();
  const users = useQuery({
    queryKey: queryKeys.adminUsers,
    queryFn: ({ signal }) => api('/api/admin/users', { signal }),
    enabled: user.isAdmin,
  });
  const update = useMutation({
    mutationFn: ({ email, bypass }) => api(`/api/admin/users/${bypass ? 'remove' : 'add'}`, { body: { email } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.adminUsers });
      queryClient.invalidateQueries({ queryKey: queryKeys.session });
    },
  });
  return { users, update };
}
